import { axiosRequest } from '../../axiosRequest';

const adapterPaymentResponse = ({ data, success }) => {
	if (success === false) return { error: true, data };

	return data;
};

export const createPaymentIntent = async ({
	hash,
	paymentMethodId,
	priceId,
}) => {
	let options = {
		method: 'post',
		url: `stripe/subscription/${hash}`,
		information: {
			paymentMethodId,
			priceId,
		},
	};

	const response = await axiosRequest(options);
	const paymentIntent = adapterPaymentResponse(response);

	return paymentIntent;
};
